import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OutrasReceitasListarRoutingModule } from "./outras-receitas-listar-routing.module";
import { OutrasReceitasListarComponent } from "./outras-receitas-listar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { ProgressSpinnerModule } from "primeng/progressspinner";




@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        TableModule,
        EditorModule,
        OutrasReceitasListarRoutingModule,    
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        CalendarModule,
        DropdownModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [OutrasReceitasListarComponent]
})
export class OutrasReceitasListarModule { }
